import currencyLib from "currency.js";

import Offer from "../../../utils/OfferClass/Offer/Offer";
import { OrderTypesEnum } from "../../../utils/enums";
import { getOrderTypeKeyStringByValue } from "../../../utils/help/orderType/orderType";
import { OfferType, reduxCartAndLoyalty } from "../../../utils/types";
import { CartLoyaltyV2SliceType } from "../types/CartLoyaltyV2Types";

export const linkUserOffers = (
  state: reduxCartAndLoyalty,
  newOffersArray: OfferType[],
  orderType: OrderTypesEnum,
  isFirstTimeOrder?: boolean,
  isTwistOfferAvailable?: boolean,
  redeemedOffer?: Offer
) => {
  state.allOrderTypesoffersArray = newOffersArray;
  state.isFirstTimeOrder = isFirstTimeOrder;
  state.isTwistOfferAvailable = isTwistOfferAvailable;

  if (redeemedOffer) {
    const redeemedOfferIndex = newOffersArray
      .filter(
        (o) =>
          !o.orderTypes ||
          o.orderTypes.includes(getOrderTypeKeyStringByValue(orderType))
      )
      .findIndex((offer) => offer.id === redeemedOffer.id);

    if (redeemedOfferIndex !== -1 && newOffersArray) {
      newOffersArray.unshift(newOffersArray.splice(redeemedOfferIndex, 1)[0]);
    }
  }
};

export const getRemainingToEligiblOfferV2 = (
  state: CartLoyaltyV2SliceType,
  offer: Offer
) => {
  if (offer.details.minSpend === 1) {
    return 0;
  }
  const remainingToEligiableOffer = currencyLib(
    offer.details.minSpend
  ).subtract(state.cart.subTotalPrice).value;

  return remainingToEligiableOffer;
};
